module.exports = __webpack_public_path__ + "static/media/image_3.a7e7ef1d.png";